import React from 'react';
import { cn } from '@/lib/utils.ts';

type Props = {
  className?: string | undefined;
};

function GolootLogo({ className }: Props) {
  return (
    <div
      className={cn(
        'w-[40px] h-[40px] bg-black shrink-0 inline-flex items-center justify-center',
        className
      )}
    >
      <svg
        width={500}
        height={483}
        viewBox="0 0 500 483"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: 21, height: 20 }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M380.245 55.6543C446.384 55.6544 500 109.299 500 175.472C500 241.645 446.384 295.288 380.245 295.288C314.106 295.288 260.489 241.645 260.489 175.472C260.489 109.298 314.106 55.6543 380.245 55.6543ZM380.245 107.575C342.766 107.575 312.383 137.974 312.383 175.472C312.383 212.97 342.766 243.368 380.245 243.368C417.724 243.368 448.106 212.97 448.106 175.472C448.106 137.974 417.724 107.575 380.245 107.575Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.9908 3.98047C20.5934 0.534344 24.6844 -0.959346 28.1288 0.64393L169.598 66.5002C210.854 85.4195 239.511 127.101 239.511 175.479C239.511 212.441 222.781 245.493 196.486 267.471C195.33 268.437 195.331 270.228 196.487 271.193C214.714 286.412 228.048 306.743 234.721 329.635C241.976 354.523 240.967 381.095 231.846 405.361C222.724 429.626 205.983 450.277 184.134 464.214C162.285 478.151 136.507 484.621 110.67 482.655C84.8331 480.688 60.3305 470.389 40.8404 453.305C21.3505 436.222 7.9244 413.274 2.5775 387.907C-2.29518 364.79 -0.21859 340.8 8.46405 318.938C9.86693 315.406 13.9783 313.919 17.4224 315.523L51.9783 331.617C55.4238 333.222 56.8797 337.31 55.633 340.902C53.2107 347.881 51.8942 355.378 51.8941 363.182C51.8941 400.68 82.2769 431.079 119.756 431.079C157.235 431.079 187.618 400.68 187.618 363.182C187.617 324.793 155.735 295.521 118.208 295.286C52.7821 294.457 0.000183058 241.135 0 175.479C0 133.115 21.9751 95.8851 55.1428 74.5795C56.7272 73.5617 56.6044 71.1664 54.8973 70.3717L6.23679 47.7196C2.7925 46.1161 1.29938 42.0223 2.90196 38.5761L18.9908 3.98047ZM119.756 107.582C82.2769 107.582 51.8941 137.981 51.8941 175.479C51.8943 212.977 82.2771 243.375 119.756 243.375C157.234 243.375 187.617 212.977 187.617 175.479C187.617 137.981 157.235 107.583 119.756 107.582Z"
          fill="white"
        />
      </svg>
    </div>
  );
}

export default GolootLogo;
